import {
  Book,
  Code1,
  Element3,
  EmptyWallet,
  ExportSquare,
  Grid4,
  Layer,
  Login,
  Logout,
  MessageQuestion,
  Money4,
  Setting2,
  UserAdd,
  NoteFavorite,
  Grid3,
  Health,
  Scroll,
  Moon,
  Sun1,
  ColorSwatch,
} from 'iconsax-react';
import { config } from './config';

export const SocialMediaList = [
  {
    link: '#',
    icon: 'google-icon.png',
    name: 'Google',
    value: 'google',
  },
  {
    link: '#',
    icon: 'linkedin-icon.png',
    name: 'Linkedin',
    value: 'linkedin',
  },
];
export const LanguageList = [
  {
    icon: 'american-flag-icon.png',
    text: 'English',
    value: 'en',
    type: '',
    logout: false,
    link: false,
  },
];
export const UserInfoList = [
  {
    icon: Setting2,
    text: 'Account',
    type: 'icon',
    iconSize: 20,
    logout: false,
    link: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? `${import.meta.env.VITE_PANEL_URL}/profile`
      : '/profile',
  },
  {
    icon: ExportSquare,
    text: 'navbar.website',
    type: 'icon',
    iconSize: 16,
    logout: false,
    link: 'https://magicalapi.com',
  },
  {
    icon: Grid4,
    text: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? 'navbar.panel'
      : 'navbar.playground',
    type: 'icon',
    iconSize: 16,
    logout: false,
    link: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? import.meta.env.VITE_PANEL_URL
      : import.meta.env.VITE_PLAYGROUND_URL,
  },
];

export const UserInfoLogoutItem = {
  icon: Logout,
  text: 'navbar.logout',
  type: 'icon',
  logout: true,
  link: false,
};
export const UserInfoLogoutList = [
  {
    icon: Login,
    text: 'navbar.login',
    type: 'icon',
    logout: false,
    link: '/login',
  },
  {
    icon: UserAdd,
    text: 'navbar.sign_up',
    type: 'icon',
    logout: false,
    link: '/sign-up',
  },
  {
    icon: ExportSquare,
    text: 'navbar.website',
    type: 'icon',
    logout: false,
    link: 'https://magicalapi.com',
  },
  {
    icon: Grid4,
    text: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? 'navbar.panel'
      : 'navbar.playground',
    type: 'icon',
    logout: false,
    link: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? import.meta.env.VITE_PANEL_URL
      : import.meta.env.VITE_PLAYGROUND_URL,
  },
];
export const AllServicesList = [
  {
    icon: 'youtube-title.png',
    icon_white: 'youtube-title.png',
    description:
      'Revolutionize your video content creation process with AI-generated title...',
    text: 'youtube_title',
    link: '/youtube-title',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'youtube-description.png',
    icon_white: 'youtube-description.png',
    description:
      'Revolutionize your video content creation process with AI-generated description...',
    text: 'youtube_description',
    link: '/youtube-description',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'youtube-hashtags.png',
    icon_white: 'youtube-hashtags.png',
    description:
      'Revolutionize your video content creation process with top trending hashtags...',
    text: 'youtube_hashtags',
    link: '/youtube-hashtags',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'youtube-keywords.png',
    icon_white: 'youtube-keywords-dark.png',
    description:
      'Optimize your YouTube content and stay ahead of the competition with our powerful keyword research tool...',
    text: 'youtube_keywords',
    link: '/youtube-keywords',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'youtube-seo.png',
    icon_white: 'youtube-seo-dark.png',
    description:
      "Elevate your video's SEO performance with our expert analysis, offering a precise SEO score and actionable optimization strategies...",
    text: 'youtube_seo',
    link: '/youtube-seo',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'profile-data.png',
    icon_white: 'profile-data-dark.png',
    description:
      'Access valuable LinkedIn profile information seamlessly for enhanced business insights and networking with LinkedIn Profile Scraper...',
    text: 'profile_data',
    link: '/profile-data',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'company-data.png',
    icon_white: 'company-data-dark.png',
    description:
      'Gain in-depth insights into LinkedIn companies with our user-friendly platform. Retrieve comprehensive public...',
    text: 'company_data',
    link: '/company-data',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'resume-parser.png',
    icon_white: 'resume-parser-dark.png',
    description:
      'Optimize your hiring process with our resume parsing service. Transform resumes into structured data,...',
    text: 'resume_parser',
    link: '/resume-parser',
    comingSoon: false,
    badge: false,
  },
  {
    icon: 'resume-score.png',
    icon_white: 'resume-score-dark.png',
    description:
      'Elevate your hiring decisions with AI-generated applicant scores. Our platform analyzes resume data...',
    text: 'resume_score',
    link: '/resume-score',
    comingSoon: false,
    badge: 'Beta',
  },
  {
    icon: 'resume-review.png',
    icon_white: 'resume-review-dark.png',
    description:
      "Transform your resume's impact with our insightful review service, delivering a comprehensive score and tailored improvement suggestions...",
    text: 'resume_review',
    link: '/resume-review',
    comingSoon: false,
    badge: false,
  },
];
export const ListSupport = [
  {
    name: 'support',
    free: true,
    basic: true,
    pro: true,
  },
  {
    name: 'access_api',
    free: false,
    basic: false,
    pro: true,
  },
];
export const TokenPackages = [
  {
    token: '30,000',
    price: 9,
  },
  {
    token: '60,000',
    price: 16,
  },
  {
    token: '120,000',
    price: 30,
  },
  {
    token: '250,000',
    price: 65,
  },
  {
    token: '500,000',
    price: 110,
  },
  {
    token: '500,000',
    price: 0,
  },
];
export const paymentInfo = [
  {
    name: 'credit_card',
    icon: 'credit_card.png',
    text: 'Credit Card / PayPal',
  },
];
export const cryptocurrencyList = [
  {
    code: 'USDT',
    name: 'USDT (TRC 20)',
  },
  {
    code: 'BTC',
    name: 'BTC (Bitcoin)',
  },
];
export const sidebarData = [
  {
    text: 'dashboard',
    icon: Element3,
    link: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? '/'
      : import.meta.env.VITE_PANEL_URL,
    external: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? false
      : true,
    target: '_self',
  },
  {
    icon: Grid3,
    text: 'Playground',
    type: 'icon',
    link: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? '/'
      : import.meta.env.VITE_PLAYGROUND_URL,
    external: !import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? false
      : true,
    target: '_self',
    badge: false,
    subItems: [
      {
        text: 'resumeServices',
        type: 'icon',
        link: null,
        external: !import.meta.env.VITE_PANEL_URL.includes(
          window.location.hostname
        )
          ? false
          : true,
        target: '_self',
        badge: false,
        subItems: [
          {
            text: 'resumeParser',
            type: 'icon',
            link: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? '/resume-parser'
              : `${import.meta.env.VITE_PLAYGROUND_URL}/resume-parser`,
            external: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? false
              : true,
            target: '_self',
            badge: false,
          },
          {
            text: 'resumeReview',
            type: 'icon',
            link: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? '/resume-review'
              : `${import.meta.env.VITE_PLAYGROUND_URL}/resume-review`,
            external: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? false
              : true,
            target: '_self',
            badge: false,
          },
          {
            text: 'resumeScore',
            type: 'icon',
            link: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? '/resume-score'
              : `${import.meta.env.VITE_PLAYGROUND_URL}/resume-score`,
            external: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? false
              : true,
            target: '_self',
            badge: true,
            badgeContent: 'Beta',
          },
        ],
      },

      {
        text: 'dataServices',
        type: 'icon',
        link: null,
        external: !import.meta.env.VITE_PANEL_URL.includes(
          window.location.hostname
        )
          ? false
          : true,
        target: '_self',
        badge: false,
        subItems: [
          {
            text: 'dataLinkedInProfile',
            type: 'icon',
            link: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? '/profile-data'
              : `${import.meta.env.VITE_PLAYGROUND_URL}/profile-data`,
            external: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? false
              : true,
            target: '_self',
            badge: false,
          },
          {
            text: 'dataLinkedInCompany',
            type: 'icon',
            link: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? '/company-data'
              : `${import.meta.env.VITE_PLAYGROUND_URL}/company-data`,
            external: !import.meta.env.VITE_PANEL_URL.includes(
              window.location.hostname
            )
              ? false
              : true,
            target: '_self',
            badge: false,
          },
        ],
      },
    ],
  },
  {
    text: 'usage',
    icon: Health,
    link: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? '/usage'
      : `${import.meta.env.VITE_PANEL_URL}/usage`,
    external: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? false
      : true,
    target: '_self',
  },
  {
    text: 'billing',
    icon: EmptyWallet,
    link: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? '/billing'
      : `${import.meta.env.VITE_PANEL_URL}/billing`,
    external: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? false
      : true,
    target: '_self',
  },
  // {
  //   text: 'pricing',
  //   icon: Money4,
  //   link: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
  //     ? '/pricing'
  //     : `${import.meta.env.VITE_PANEL_URL}/pricing`,
  //   external: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
  //     ? false
  //     : true,
  //   target: '_self',
  // },
  {
    text: 'apiInfo',
    icon: Scroll,
    link: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? '/api-info'
      : `${import.meta.env.VITE_PANEL_URL}/api-info`,
    external: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
      ? false
      : true,
    target: '_self',
  },
  {
    text: 'whatsNew',
    icon: NoteFavorite,
    link: import.meta.env.VITE_MAGICAL_API_BLOG_URL,
    external: true,
    target: '_blank',
    badge: false,
  },
  // {
  //   text: 'settings',
  //   icon: Setting2,
  //   link: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
  //     ? '/profile'
  //     : `${import.meta.env.VITE_PANEL_URL}/profile`,
  //   external: import.meta.env.VITE_PANEL_URL.includes(window.location.hostname)
  //     ? false
  //     : true,
  //   target: '_self',
  // },
];

export const playgroundExampleList = {
  youtubeTitle: [
    {
      text: 'Funny',
      title: 'Vlog about living in tiny apartment in New York',
      prompt_sentence: 'Vlog about living in tiny apartment in New York',
      suggestion_goal: 'Generate Titles',
      tone: 'Funny',
      count: 2,
    },
    {
      text: 'Formal',
      title: 'How to create a profitable Shopify store',
      prompt_sentence: 'How to create a profitable Shopify store',
      suggestion_goal: 'Generate Titles',
      tone: 'Formal',
      count: 2,
    },

    {
      text: 'Narrative',
      title: '7 days surviving in a cave with limited food',
      prompt_sentence: '7 days surviving in a cave with limited food',
      suggestion_goal: 'Generate Titles',
      tone: 'Narrative',
      count: 2,
    },
    {
      text: 'Technical',
      title: 'Soft Skills Interview Questions and Answers',
      prompt_sentence: 'Soft Skills Interview Questions and Answers',
      suggestion_goal: 'Generate Titles',
      tone: 'Technical',
      count: 2,
    },
  ],

  youtubeSEO: [
    {
      title: 'Microsoft Event in less than 2 minutes',
      text: 'Microsoft',
      video_url: 'https://www.youtube.com/watch?v=PZZI1QXlM80',
    },
    {
      title: 'Introducing Apple Vision Pro',
      text: 'Apple',
      video_url: 'https://www.youtube.com/watch?v=TX9qSaGXFyg',
    },
  ],
  youtubeKeyword: [
    {
      title: 'Movie Trailers',
      text: 'Worldwide-English',
      search_sentence: 'movie trailers',
      country: 'Worldwide',
      language: 'English',
    },
    {
      title: 'Music Videos',
      text: 'Turkey-Turkish',
      search_sentence: 'music videos',
      country: 'Turkey',
      language: 'Turkish',
    },
    {
      title: 'Minecraft',
      text: 'United States-English',
      search_sentence: 'minecraft',
      country: 'United States',
      language: 'English',
    },
    {
      title: 'Shopify Store',
      text: 'United Arab Emirates-Arabic',
      search_sentence: 'Shopify Store',
      country: 'United Arab Emirates',
      language: 'Arabic',
    },
  ],
  youtubeDescription: [
    {
      text: 'Funny',
      title: 'Vlog about living in tiny apartment in New York',
      prompt_sentence: 'Vlog about living in tiny apartment in New York',
      tone: 'Funny',
      count: 2,
    },
    {
      text: 'Formal',
      title: 'How to create a profitable Shopify store',
      prompt_sentence: 'How to create a profitable Shopify store',
      tone: 'Formal',
      count: 2,
    },

    {
      text: 'Narrative',
      title: '7 days surviving in a cave with limited food',
      prompt_sentence: '7 days surviving in a cave with limited food',
      tone: 'Narrative',
      count: 2,
    },
    {
      text: 'Technical',
      title: 'Soft Skills Interview Questions and Answers',
      prompt_sentence: 'Soft Skills Interview Questions and Answers',
      tone: 'Technical',
      count: 2,
    },
  ],
  youtubeHashtags: [
    {
      text: '',
      title: 'Vlog',
      keyword: 'Vlog',
    },
    {
      text: '',
      title: 'Tutorial',
      keyword: 'Tutorial',
    },
    {
      text: '',
      title: 'Music',
      keyword: 'Music',
    },
    {
      text: '',
      title: 'DIY',
      keyword: 'DIY',
    },
  ],

  linkedInProfile: [
    {
      title: '',
      text: "Conan O'Brien",
      profile_name: 'https://www.linkedin.com/in/conanobrien/',
    },
    {
      title: '',
      text: 'Shravan Goli',
      profile_name: 'https://www.linkedin.com/in/shravan/',
    },
  ],

  linkedInCompany: [
    {
      title: 'LinkedIn Company URL',
      text: 'https://www.linkedin.com/company/spotify',
      company_value: 'https://www.linkedin.com/company/spotify',
      category: 'linkedin_url',
    },
    {
      title: 'Company Website',
      text: 'apple.com',
      company_value: 'apple.com',
      category: 'company_website',
    },
    {
      title: 'Company Name',
      text: 'Microsoft',
      company_value: 'microsoft',
      category: 'company_name',
    },
  ],
  resumeParser: [
    {
      title: '',
      text: 'Sales Professional',
      resume_url:
        'https://resume-resource.com/wp-content/uploads/00123-sales-professional-resume.pdf',
    },
    {
      title: '',
      text: 'Product Manager',
      resume_url:
        'https://resume-resource.com/wp-content/uploads/00016-poduct-manager-resume-example.pdf',
    },
  ],
  resumeReview: [
    {
      title: '',
      text: 'Sales Professional',
      resume_url:
        'https://resume-resource.com/wp-content/uploads/00123-sales-professional-resume.pdf',
    },
    {
      title: '',
      text: 'Product Manager',
      resume_url:
        'https://resume-resource.com/wp-content/uploads/00016-poduct-manager-resume-example.pdf',
    },
  ],
  resumeScore: [
    {
      title: '',
      text: 'Sales Professional',
      resume_url:
        'https://resume-resource.com/wp-content/uploads/00123-sales-professional-resume.pdf',
      job_description: 'Sales Professional',
    },
    {
      title: '',
      text: 'Product Manager',
      resume_url:
        'https://resume-resource.com/wp-content/uploads/00016-poduct-manager-resume-example.pdf',
      job_description: 'Product Manager',
    },
  ],
};
export const PricingTableList = [
  {
    name: 'profile-data',
    free: 'limited_response',
    basic: '600',
    pro: '2,000',
    price: '150',
  },
  {
    name: 'company-data',
    free: 'limited_response',
    basic: '600',
    pro: '2,000',
    price: '150',
  },
  {
    name: 'resume-parser',
    free: 'limited_response',
    basic: '600',
    pro: '2,000',
    price: '150',
  },
  {
    name: 'resume-score',
    free: 'limited_response',
    basic: '360',
    pro: '1,200',
    price: '250',
  },
  {
    name: 'resume-review',
    free: 'limited_response',
    basic: '360',
    pro: '1,200',
    price: '250',
  },
];
export const serviceSuggest = [
  {
    img: 'service-suggestions-company-data.png',
    title: 'company_data',
    id: 'company-data',
    icon: 'company-data.svg',
    icon_white: 'company-data-dark.svg',
    link: '/company-data',
    showInRoute: ['/profile-data'],
    description: 'company_data',
  },

  {
    img: 'service-suggestions-profile-data.png',
    title: 'profile_data',
    id: 'profile-data',
    icon: 'profile-data.svg',
    icon_white: 'profile-data-dark.svg',
    link: '/profile-data',
    showInRoute: ['/company-data'],
    description: 'profile_data',
  },
  {
    img: 'service-suggestions-resume-parser.png',
    title: 'resume_parser',
    id: 'resume-parser',
    icon: 'resume-parser.svg',
    icon_white: 'resume-parser-dark.svg',
    link: '/resume-parser',
    showInRoute: ['/resume-score'],
    description: 'resume_parser',
  },
  {
    img: 'service-suggestions-resume-review.png',
    title: 'resume_review',
    id: 'resume-review',
    icon: 'resume-review.svg',
    icon_white: 'resume-review-dark.svg',
    link: '/resume-review',
    showInRoute: ['/resume-score'],
    description: 'resume_review',
  },
  {
    img: 'service-suggestions-resume-score.png',
    title: 'resume_score',
    id: 'resume-score',
    icon: 'resume-score.svg',
    icon_white: 'resume-score-dark.svg',
    link: '/resume-score',
    showInRoute: ['/resume-review'],
    description: 'resume_score',
  },
];
export const productCategory = [
  {
    name: 'resume',
    name_single: 'resume_single',
    listService: [
      {
        title: 'resume_parser',
        url: 'resume-parser',
        icon_url_dark: 'resume-parser-icon-dark.svg',
        icon_url_light: 'resume-parser-icon-light.svg',
      },
      {
        title: 'resume_review',
        url: 'resume-review',
        icon_url_dark: 'resume-review-icon-dark.svg',
        icon_url_light: 'resume-review-icon-light.svg',
      },
      {
        title: 'resume_score',
        url: 'resume-score',
        icon_url_dark: 'resume-score-icon-dark.svg',
        icon_url_light: 'resume-score-icon-light.svg',
      },
    ],
    url: '/?product=magical-resume',
    icon: 'resume-icon.png',
    iconDark: 'Resume-icon-dark.png',
    color: 'danger',
    activeBgColorLight: '#FFEDEA',
    activeBgColorDark: '#F9C5C4',
  },
  {
    name: 'data',
    name_single: 'data_single',
    listService: [
      {
        title: 'profile_data',
        url: 'profile-data',
        icon_url_dark: 'profile-data-icon-dark.svg',
        icon_url_light: 'profile-data-icon-light.svg',
      },
      {
        title: 'company_data',
        url: 'company-data',
        icon_url_dark: 'company-data-icon-dark.svg',
        icon_url_light: 'company-data-icon-light.svg',
      },
    ],
    url: '/?product=magical-data',
    icon: 'data-icon.png',
    iconDark: 'Data-icon-dark.png',
    color: 'success',
    activeBgColorLight: '#EBFFF1',
    activeBgColorDark: '#99EBDD',
  },
];
export const servicesRestrictedFields = {
  'company-data': [
    'locations',
    'products',
    'employees',
    'organizationType',
    'specialties',
  ],
  'profile-data': [
    'experience',
    'education',
    'certifications',
    'honors_and_awards',
    'volunteerings',
    'publications',
    'projects',
    'courses',
  ],
  'resume-score': ['reason'],
  'resume-parser': ['educations', 'work_experiences', 'project_experiences'],
  'resume-review': [],
};

export const verificationPageServiceList = [
  {
    id: 19,
    name: 'LinkedIn Company Scraper',
    key: 'company-data',
    description:
      'Extracting all publicly available data from company pages is the primary objective of LinkedIn Company Scraper.',
    is_subscribed: true,
    icon_url_dark: 'company-data-dark.svg',
    icon_url_light: 'company-data.svg',
    documentation_link: 'https://doc.magicalapi.com/company-data',
    playground_link: 'https://test-playground.magicalapi.org/company-data',
  },
  {
    id: 18,
    name: 'LinkedIn Profile Scraper',
    key: 'profile-data',
    description:
      'Access valuable LinkedIn profile information seamlessly for enhanced business insights and networking with LinkedIn Profile Scraper...',
    is_subscribed: true,
    icon_url_dark: 'profile-data-dark.svg',
    icon_url_light: 'profile-data.svg',
    documentation_link: 'https://magicalapi.readme.io/reference/profile-data',
    playground_link: 'https://test-playground.magicalapi.org/profile-data',
  },
  {
    id: 17,
    name: 'Resume Parser',
    key: 'resume-parser',
    description:
      'Optimize your hiring process with our resume parsing service. Transform resumes into structured data,...',
    is_subscribed: true,
    icon_url_dark: 'resume-parser-dark.svg',
    icon_url_light: 'resume-parser.svg',
    documentation_link: 'https://magicalapi.readme.io/reference/resume-parser',
    playground_link: 'https://test-playground.magicalapi.org/resume-parser',
  },
  {
    id: 11,
    name: 'Resume Checker',
    key: 'resume-review',
    description:
      "Transform your resume's impact with our insightful review service, delivering a comprehensive score and tailored improvement suggestions...",
    is_subscribed: true,
    icon_url_dark: 'resume-review-dark.svg',
    icon_url_light: 'resume-review.svg',
    documentation_link: 'https://doc.magicalapi.com/resume-review',
    playground_link: 'https://test-playground.magicalapi.org/resume-review',
  },
  {
    id: 4,
    name: 'Resume Matcher',
    key: 'resume-score',
    description:
      'Elevate your hiring decisions with AI-generated applicant scores. Our platform analyzes resume data...',
    is_subscribed: true,
    icon_url_dark: 'resume-score-dark.svg',
    icon_url_light: 'resume-score.svg',
    documentation_link: 'https://doc.magicalapi.com/resume-score',
    playground_link: 'https://test-playground.magicalapi.org/resume-score',
  },
];
